module.exports = __webpack_public_path__ + "media/images/icons/map-marker-da4f1d0ea4d9c6baf548ef44fa120692.svg";